<template>
  <div class="h-100">
    <v-navigation-drawer
      fixed
      v-model="drawer"
      app
    >
      <div class="userView w-100">
        <header>
          <img v-if="$route.meta.image" :src="background"  class="responsive-img" alt="">
        </header>
        <v-list id="userList" class="pa-1">
          <v-list-tile avatar>
              <v-list-tile-avatar
                v-if="userProfile.name"
                color="secondary"
                class="headline font-weight-light white--text"
              >
              {{ userProfile.name.charAt(0) }}
              </v-list-tile-avatar>
              <v-list-tile-content>
              <v-list-tile-title></v-list-tile-title>
              </v-list-tile-content>
          </v-list-tile>
        </v-list>
        <v-list two-line>
          <v-list-tile
            @click=""
          >
            <v-list-tile-content>
              <v-list-tile-title>{{ userProfile.name }}</v-list-tile-title>
              <v-list-tile-sub-title>{{ userProfile.email }}</v-list-tile-sub-title>
            </v-list-tile-content>

            <!-- <v-list-tile-action>
              <v-btn icon ripple>
                <v-icon color="grey lighten-1">info</v-icon>
              </v-btn>
            </v-list-tile-action> -->
          </v-list-tile>
          <v-divider></v-divider>
        </v-list>
      </div>
      <v-list class="pt-0" dense>
          <v-list-tile class="hidden-xs-only" v-for="item in navigationItems" :key="item.title" @click="goTo(item.title)">
              <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile-content>
          </v-list-tile>
        <v-subheader>Tools</v-subheader>
        <v-list-tile v-for="item in drawerItems" :key="item.title" @click="openTool(item)">
            <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
        </v-list-tile>
        <v-divider inset></v-divider>
        <v-list-tile @click="logout">
          <v-list-tile-action>
          <v-icon></v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
          <v-list-tile-title>Logout</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>

    <v-toolbar absolute color="transparent" flat dark>
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title>{{$route.name}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-avatar
          tile="tile"
          size="avatarSize"
          color="transparent"
        >
      </v-avatar>
    </v-toolbar>
      <v-content>
        <v-container fill-height>
          <v-layout
            row
            wrap
            align-content-start
          >
            <v-flex xs12>
              <header>
                <img v-if="$route.meta.image" :src="background"  class="responsive-img" alt="">
              </header>
            </v-flex>
            <v-flex xs12 class="min-height">
              <slot :nofiticationsAlt="notifications" />
            </v-flex>
          </v-layout>
        </v-container>
      </v-content>

      <v-bottom-nav :value="true" class="hidden-sm-and-up" :active.sync="e1" shift fixed :app="isTouch" color="primary">
        <v-btn v-for="item in navigationItems" :disabled="isDisabled(item)" :key="item.title" flat color="white" :value="item.title" @click="goTo(item.title)">
          <span>{{item.title}}</span>
          <v-icon v-if="item.title == 'Feedback'" :class="{'notify' : notifications.length > 0}">{{item.icon}}</v-icon>
          <v-icon v-if="item.title !== 'Feedback'">{{item.icon}}</v-icon>
        </v-btn>
      </v-bottom-nav>

      <dialogController></dialogController>

  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { db, auth } from '@/services/firebase'

import dialogController from '@/components/members/dialogController.vue'
export default {
  name: 'app',
  components: {
    dialogController
  },
  data () {
    return {
      e1: this.$route.name,
      drawer: null,
      drawerItems: [
        { value: 'addWeightGoals', title: 'Add Weight Goals', icon: 'add', blocked: false },
        { value: 'addMeasurements', title: 'Add Measurements', icon: 'add', blocked: true },
        { value: 'addPhotos', title: 'Add Progress Photos', icon: 'add', blocked: true },
        { value: 'settings', title: 'Member Settings', icon: 'settings', blocked: false }
      ],
      navigationItems: [
        { title: 'Home', icon: 'home' },
        { title: 'Nutrition', icon: 'local_dining' },
        { title: 'Workouts', icon: 'fitness_center' },
        { title: 'Feedback', icon: 'question_answer' }
      ],
      notifications: []
    }
  },
  props: ['isTouch'],
  mounted () {
    this.$nextTick(() => {
      this.getNotifications()
    })
  },
  methods: {
    getNotifications: function () {
      var self = this
      db.collection('notifications').where('user_id', '==', self.currentUser).where('read_at', '==', null)
        .onSnapshot(function (querySnapshot) {
          querySnapshot.docChanges().forEach(function (change) {
            if (change.type === 'added') {
              var newItem = change.doc.data()
              self.$set(newItem, 'id', change.doc.id)
              self.notifications.push(newItem)
            }
            if (change.type === 'modified') {
              let i = self.notifications.map(item => item.id).indexOf(change.doc.id) // find index of your object
              self.notifications.splice(i, 1)
            }
            if (change.type === 'removed') {
              let i = self.notifications.map(item => item.id).indexOf(change.doc.id) // find index of your object
              self.notifications.splice(i, 1)
            }
          })
        })
    },
    goTo: function (title) {
      if (this.isTouch) {
        this.drawer = false
      }
      setTimeout(() => this.$router.push({name: title}), 200)
    },
    openTool: function (item) {
      if (item.blocked && this.userProfile.trial) {
        alert('Not Available while on trial!')
      } else {
        if (this.$root.isTouch) {
          this.drawer = false
          this.$router.push({name: item.title})
        }
      }
    },
    isDisabled (item) {
      if (item.title === 'Nutrition' && this.userProfile.trial) {
        return true
      } return false
    },
    logout () {
      var self = this
      auth.signOut()
        .then(function () {
          self.$store.dispatch('logout').then(
            self.$router.push('/login')
          )
        })
        .catch(function () {
          // An error happened
        })
    }
  },
  computed: {
    ...mapGetters({
      currentUser: 'currentUser',
      userProfile: 'userProfile'
    }),
    background () {
      return require('@/assets/header/' + this.$route.meta.image + '.jpg')
    },
    backgroundNav () {
      return require('@/assets/img/logo-color.png')
    }
  }
}
</script>

<style scoped >
 header {
   padding: 0px;
   overflow: hidden;
 }
 .min-height {
    min-height: calc(100% - 156px);
 }
 .userView #userList {
  margin-top: -64px;
 }
  .v-bottom-nav .v-btn:not(.v-btn--active) {
    -webkit-filter: none;
    filter: none;
  }
  .v-btn .notify:after {
    content:"• ";
    position: absolute;
    top: -15px;
    color: #3bbb51;
    font-size: 30px;
  }
  .v-btn--active {
  }
 .h-100 {
   height: 100%;
 }
  @media only screen and (max-width: 959px) {
    .container {
      padding: 0px!important;
    }
    .padding {
      padding: 16px;
    }
  }
  @media (min-width: 960px) and (max-width: 1263px) {
    .container {
      padding: 0px!important;
    }
    .padding {
      padding: 24px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layouts/default.vue